/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1AccesscontrolPermissionsBatch202,
  PostApiV1AccesscontrolPermissionsBatch400,
  PostApiV1AccesscontrolPermissionsBatch401,
  PostApiV1AccesscontrolPermissionsBatch500,
  PostApiV1AccesscontrolPermissionsBatchMutationRequest,
  PostApiV1AccesscontrolPermissionsBatchMutationResponse,
} from "../../types/accessControlPermissionsController/PostApiV1AccesscontrolPermissionsBatch.ts";
import { batchPermissionViewModelSchema } from "../batchPermissionViewModelSchema.ts";

/**
 * @description (Accepted) Requisição aceita.
 */
export const postApiV1AccesscontrolPermissionsBatch202Schema =
  z.any() as unknown as ToZod<PostApiV1AccesscontrolPermissionsBatch202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1AccesscontrolPermissionsBatch400Schema =
  z.any() as unknown as ToZod<PostApiV1AccesscontrolPermissionsBatch400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1AccesscontrolPermissionsBatch401Schema =
  z.any() as unknown as ToZod<PostApiV1AccesscontrolPermissionsBatch401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1AccesscontrolPermissionsBatch500Schema =
  z.any() as unknown as ToZod<PostApiV1AccesscontrolPermissionsBatch500>;

export const postApiV1AccesscontrolPermissionsBatchMutationRequestSchema =
  z.lazy(
    () => batchPermissionViewModelSchema,
  ) as unknown as ToZod<PostApiV1AccesscontrolPermissionsBatchMutationRequest>;

export const postApiV1AccesscontrolPermissionsBatchMutationResponseSchema =
  z.lazy(
    () => postApiV1AccesscontrolPermissionsBatch202Schema,
  ) as unknown as ToZod<PostApiV1AccesscontrolPermissionsBatchMutationResponse>;
